<template>
  <div class="training-player-component training-audio-player-component"
       :class="[playing ? 'playing' : '']"
       @click="handleClick"
  >
    <div class="icon-container">
      <ym-loading v-if="playing && loading"
                  type="fading-circle"
      />
      <ym-icon v-else
                :name="icon"
      />
    </div>
    <div class="player-info">
      <span class="player-title">{{ title }}</span>
      <span class="player-duration">{{ duration }}</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { Loading } from '@ymba/ym-ui';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';
  import { upperCaseFirst } from '@/utils';
  import validator from '@/utils/validator';

  export default {
    name: 'LevelAudioPlayer',
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      'ym-loading': Loading,
    },
    data() {
      return {
        disabled: false,
        isSetList: true,
      };
    },
    props: {
      current: {
        type: Number,
        required: true,
      },
      source: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
      duration: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
        validator(val) {
          return ['level', 'task', 'work'].includes(val);
        },
      },
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      playing() {
        return this.player.playingId === this.current;
      },
      icon() {
        return this.playing ? 'pause-fill' : 'play-fill';
      },
      loading() {
        const { player } = this;
        const { loadingStatus } = player;
        return loadingStatus === 'loading';
      },
    },
    watch: {
      source(val) {
        this.isSetList = !(val.mp3.length !== 0);
      },
    },
    methods: {
      validatorSrc() {
        if (this.source.mp3.length === 0) {
          this.$dialog.alert({
            title: '提示',
            message: '音频链接出错，请刷新页面',
            confirmButtonText: '好的',
            closeOnClickOverlay: false,
          });
          this.$emit('emptysrc');
          return false;
        }
        return true;
      },
      async handleClick() {
        if (this.disabled) return;

        this.disabled = true;
        const { player } = this;

        // 正在播放当前音频
        if (this.playing) {
          player.pause();
          this.disabled = false;
          return;
        }

        if (this.validatorSrc()) {
          if (!this.isSetList) {
            const { current: id, source, duration } = this;
            this.setGlobalPlayerInfo([{
              id,
              source,
              duration,
            }], true, false, `training${upperCaseFirst(this.type)}`);
          }
          player.play();
        }

        this.disabled = false;
      },
    },
    created() {
      this.isSetList = false;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-player-component {
    display: flex;
  }

  .icon-container {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border-radius: @border-radius-round;
    color: @training-primary-color;
    background: @color-white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: @font-size-large;
  }

  .player-info {
    display: flex;
    flex-direction: column;
    margin-left: @size-base;
  }

  .player-title {
    font-size: @font-size-medium;
    color: @color-text-base;
    margin-bottom: @size-extra-small;
  }

  .player-duration {
    font-size: @font-size-base;
    color: @color-text-light;
  }
</style>
